import React from 'react';

const PinIcon = () => (
  <svg className="w-3 h-3 text-emerald-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
  </svg>
);

const IconBtn = ({ label, children }) => (
  <button
    type="button"
    className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 hover:text-emerald-600 transition-colors"
    aria-label={label}
  >
    {children}
  </button>
);

const PersonIcon = () => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const GroupIcon = () => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
  </svg>
);

const HighlightCard = React.memo(({ item }) => (
  <article className="rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow flex">
    {/* Text side */}
    <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
      <div>
        <h4 className="font-semibold text-gray-900 text-sm line-clamp-1">{item.title}</h4>
        <p className="flex items-center gap-1 text-[11px] text-gray-500 mt-1">
          <PinIcon />
          <span className="line-clamp-1">{item.locationText}</span>
        </p>
        {item.infoText && (
          <p className="text-[11px] text-gray-400 mt-1 flex items-center gap-1">
            <svg className="w-3 h-3 text-blue-400 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clipRule="evenodd" />
            </svg>
            {item.infoText}
          </p>
        )}
      </div>
      <div className="flex items-center gap-1.5 mt-2">
        <IconBtn label="Person"><PersonIcon /></IconBtn>
        <IconBtn label="Group"><GroupIcon /></IconBtn>
      </div>
    </div>

    {/* Image side */}
    <div className="w-28 sm:w-32 shrink-0">
      <img
        src={item.imageUrl}
        alt={item.title}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  </article>
));

HighlightCard.displayName = 'HighlightCard';

export default HighlightCard;
